import './App.css';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Navbar from './layout/Navbar';
import Home from './pages/Home';
import WhatsAppContact from './pages/WhatsAppContact';
import WhatsAppThankYou from './pages/WhatsAppThankYou';
import EmailContact from './pages/EmailContact';
import EmailThankYou from './pages/EmailThankYou';
import Contact from './pages/Contact';
import Impressum from './pages/Impressum';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';

let Analytics = () => null;
try {
  // Optional dependency in tests / local environments
  // eslint-disable-next-line global-require
  Analytics = require('@vercel/analytics/react').Analytics;
} catch {
  Analytics = () => null;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <Helmet>
          <script async src="https://www.googletagmanager.com/gtag/js?id=AW-930752529"></script>
          <script>{`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-930752529');
          `}</script>
        </Helmet>
        <Router>
          <Navbar/>
          <Routes>
            <Route path='/' element={<Home/>}></Route>
            <Route path='/whatsapp-contact' element={<WhatsAppContact/>}></Route>
            <Route path='/whatsapp-thank-you' element={<WhatsAppThankYou/>}></Route>
            <Route path='/email-contact' element={<EmailContact/>}></Route>
            <Route path='/email-thank-you' element={<EmailThankYou/>}></Route>
            <Route path='/kontakt' element={<Contact/>}></Route>
            <Route path='/impressum' element={<Impressum/>}></Route>
          </Routes>
          <Analytics />
        </Router>
      </HelmetProvider>
    </div> 
  );
}

export default App;